import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';
import Const from 'constants';

class SelectKeyPlayerLineupPosition extends Component {
    getOptions() {
        return {
            [Const.CAPTAIN_MODE]: 'CPT/MVP',
            [Const.FLEX_MODE]: 'Flex',
        };
    }

    render() {
        return (
            <SimpleSelect
                className="form-control input-md"
                value={this.props.value}
                options={this.getOptions()}
                onChange={this.props.onChange}
            />
        );
    }
}

export default SelectKeyPlayerLineupPosition;
